import NpawMonitoring from './NpawMonitoring.js';
import withContexts from './withContexts.hoc.js';
import 'react';
import 'prop-types';
import 'youboralib';
import 'react/jsx-runtime';
import '@dtvgo/npaw-context';

var index = withContexts(NpawMonitoring);

export { NpawMonitoring, index as default };
//# sourceMappingURL=index.js.map
